import { render, staticRenderFns } from "./AddNewTruckerForm.vue?vue&type=template&id=1bd83423&"
import script from "./AddNewTruckerForm.vue?vue&type=script&lang=js&"
export * from "./AddNewTruckerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports